/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="b6067052-05c9-45b7-9446-51a522a9d21f" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="bfc6c2aa-7140-40c7-85af-3587e20ec30b" x="0" y="0" width="24" height="24" maskUnits="userSpaceOnUse">
            <g id="b5375c7a-2286-4982-8c93-c91e9d153837">
              <path id="ef4b1bc1-b3f7-4c3c-9230-f04c3e7e0863" d="M21.72,6h.13a1.16,1.16,0,0,1,.76.47h0l1.12,1.41a1.09,1.09,0,0,1,.26.83,1,1,0,0,1-.48.73c-.05.05-2.4,1.79-4.59,3.42h0V18H0V8.12H18.49L20,7l1-.74A1.12,1.12,0,0,1,21.85,6ZM17.2,9.07H1v8H17.92V13.61l-2.32,1.72h0l-2.29.19v.79H8.67v-.95h3.11l1.3-3.22.11-.08ZM6.2,12.2l.71.67-1.45,1.4,1.45,1.4-.71.67-1.44-1.4-1.45,1.4-.7-.67,1.45-1.4-1.45-1.4.7-.67,1.45,1.39ZM21.71,7s-.05,0-.11.06h0l-7.69,5.72-.75,1.84,2.08-.16,7.66-5.7.05,0c.05,0,.06-.05.06-.07a.37.37,0,0,0-.07-.14h0l-1.12-1.4A.38.38,0,0,0,21.71,7Z" fill="#fff" style={{ fillRule: 'evenodd' }}/>
            </g>
          </mask>
        </defs>
        <g id="a9d52f9a-d861-4776-9ce3-f232a9edbd49">
          <g id="b3a26504-b122-4725-8259-a9aadea72e1c">
            <g id="e3f211b1-dc19-4f4b-9289-00bf6f2108f8">
              <path id="b5ef76ae-3991-42f4-80f6-30eed479da88" d="M21.72,6h.13a1.16,1.16,0,0,1,.76.47h0l1.12,1.41a1.09,1.09,0,0,1,.26.83,1,1,0,0,1-.48.73c-.05.05-2.4,1.79-4.59,3.42h0V18H0V8.12H18.49L20,7l1-.74A1.12,1.12,0,0,1,21.85,6ZM17.2,9.07H1v8H17.92V13.61l-2.32,1.72h0l-2.29.19v.79H8.67v-.95h3.11l1.3-3.22.11-.08ZM6.2,12.2l.71.67-1.45,1.4,1.45,1.4-.71.67-1.44-1.4-1.45,1.4-.7-.67,1.45-1.4-1.45-1.4.7-.67,1.45,1.39ZM21.71,7s-.05,0-.11.06h0l-7.69,5.72-.75,1.84,2.08-.16,7.66-5.7.05,0c.05,0,.06-.05.06-.07a.37.37,0,0,0-.07-.14h0l-1.12-1.4A.38.38,0,0,0,21.71,7Z" fill="#05273e" className="icon-fill"/>
            </g>
            <g style={{ mask: 'url(#bfc6c2aa-7140-40c7-85af-3587e20ec30b)' }}>
              <g id="ae78b468-02b8-439d-a47a-41a32db80b52">
                <rect id="e45a0f9d-2146-4977-9557-888376ae2f65" width="24" height="24" fill="#002b49" className="icon-fill"/>
              </g>
            </g>
            <g style={{ mask: 'url(#bfc6c2aa-7140-40c7-85af-3587e20ec30b)' }}>
              <rect id="e7d2a4d3-7a0e-4d1e-99b9-4f910d452f68" width="24" height="24" className="icon-fill"/>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'CheckbookIcon';

export default Icon;
